import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 11,
    fontFamily: 'Helvetica',
    lineHeight: 1.6,
  },
  section: {
    marginBottom: 20,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  sectionLeft: {
    flex: 1,
    marginRight: 10,
  },
  sectionRight: {
    flex: 1,
    marginLeft: 10,
  },
  logo: {
    width: 240,
    height: 'auto',
    marginBottom: 25,
    alignSelf: 'left',
  },
  heading: {
    fontSize: 14,
    marginBottom: 8,
    fontWeight: 'bold',
  },
  subHeading: {
    fontSize: 13,
    marginBottom: 6,
    textDecoration: 'underline',
  },
  bold: {
    fontWeight: 'bold',
  },
  boldMargin: {
    fontWeight: 'bold',
    marginTop: 15
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  rowBetween: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  rowBetweenBold: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
    fontWeight: 'bold',
    marginTop: 15
  },
  textLeft: {
    maxWidth: 400,
    textAlign: 'left',
  },
  textRight: {
    textAlign: 'right',
  },
  label: {
    fontWeight: 'bold',
  },
  line: {
    height: 1,
    backgroundColor: '#0099ff',
    marginBottom: 10,
  },
  smallText: {
    textAlign: 'center',
    fontSize: 9,
    color: '#555',
  },
  center: {
    textAlign: 'center',
  },
  invoiceTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 12
  },
  placeholderImage: {
    width: 80,
    height: 80,
    marginBottom: 10,
    backgroundColor: '#eee',
  },
});

export default function InvoicePdf({ data, result }) {
  return (
    <Document>
      <Page style={styles.page}>
        {/* Placeholder Logo */}
        <Image
          style={styles.logo}
          src="/images/Invoice-Instagram-Logo.png"
        />

        {/* Invoice Summary */}
        <View style={styles.row}>
          <View style={styles.sectionLeft}>
            <Text>Billed To:</Text>
            <Text style={styles.bold}>Meta Platforms Inc.</Text>
            <Text>1 Hacker Way</Text>
            <Text>Menlo Park, CA 94025</Text>
            <Text>United States</Text>
          </View>

          <View style={styles.sectionRight}>
            <Text>From:</Text>
            <Text style={styles.bold}>Name: {data.fullName}</Text>
            <Text>Instagram: @{data.igHandle}</Text>
            <Text>Invoice Number: {data.invoiceNumber}</Text>
          </View>
        </View>

        <View >
          <Text style={styles.bold}>Attn: Accounts Receivable</Text>
          <Text style={styles.bold}>Re: Unpaid Claim - Creative Labour, Attention and Wellbeing Damages</Text>
        </View>

        <View style={styles.rowBetweenBold} >
          <Text style={styles.textLeft}>Description</Text>
          <Text style={styles.textRight}>Amount (USD)</Text>
        </View>
        <View style={styles.line} />

        {/* Value Breakdown */}
        <View style={styles.section}>

          <Text style={styles.boldMargin}>Content Revenue</Text>
          <View style={styles.rowBetween}>  
            <Text style={styles.textLeft} >Calculated earnings derived from the visual reach of posts and stories based on CPM advertising rates.</Text>
            <Text style={styles.textRight}>${result.contentRevenue}</Text>
          </View>


          <Text style={styles.boldMargin}>Doomscroll Value</Text>
          <View style={styles.rowBetween}>  
            <Text style={styles.textLeft} >Compensation for time spent passively engaging with Instagram, generating monetizable attention for Meta's advertising partners based on ARPP rates.</Text>
            <Text style={styles.textRight}>${result.scrollTimeValue}</Text>
          </View>

          <Text style={styles.boldMargin}>Creative Labour Value</Text>
          <View style={styles.rowBetween}>  
            <Text style={styles.textLeft} >Remuneration for original content production, including planning, editing, and publication.</Text>
            <Text style={styles.textRight}>${result.creativeLabourValue}</Text>
          </View>

          <Text style={styles.boldMargin}>Wellbeing Damages</Text>
          <View style={styles.rowBetween}>  
            <Text style={styles.textLeft} >Remuneration for the emotional and social cost of Instagram use.</Text>
            <Text style={styles.textRight}>$6000</Text>
          </View>
        
        </View>

        <View style={styles.rowBetweenBold} >
          <Text style={styles.textLeft}>Payment Information:</Text>
          <Text style={styles.textRight}>Total Due to User (USD)</Text>
        </View>
        <View style={styles.line} />

        <View style={styles.rowBetween} >
          <View style={styles.textLeft}>
            <Text>Payment Method: {data.paymentMethod ? data.paymentMethod : 'On Request'}</Text>
            <Text>Payment Address: {data.paymentLink ?  data.paymentLink: 'On Request'}</Text>
            <Text>Payment Due: Within 30 days</Text>
          </View>
          <View style={styles.textRight}>
            <Text style={styles.invoiceTitle}>${result.total}</Text>
          </View>
        </View>
        <View style={styles.section}></View>
        <View style={styles.section}>
          <Text style={styles.smallText}>
            This invoice represents a share of the value generated for Meta Platforms, Inc. and a measurement of the social cost of the platform, through unpaid creative labour, time on platform, and attention economy contributions. It is a symbolic and artistic action as part of the Meta Invoice project by Dadada.
          </Text>
        </View>
      </Page>
    </Document>
  );
}
